import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class SalePaymentStore extends LocalModel {
    constructor() {
        super('salePayment', {
            namePlural: 'salePayments',
            sort: '-paidDate -createdDate',
            limit: 500,
            api: {
                search: {
                    url: '/api/salepayments/',
                    params: {
                        limit: 300,
                        sort: '-paidDate -createdDate',
                    },
                },
                load: {
                    url: '/api/salepayments/',
                    params: {},
                },
                save: {
                    url: '/api/salepayments/',
                    params: {},
                },
                delete: {
                    url: '/api/salepayments/',
                    params: {},
                },
            },
        });
    }

    @observable newSalePayment = {};

    @observable salePayment = {};

    @observable salePayments = [];

    @observable sort = '-paidDate -createdDate';

    @observable offset = 0;

    @observable limit = 100;

    @observable currentPage = 1;

    // TICKET-01777: filter-following sums returned by GET /api/salepayments/ next to `total`.
    @observable totalAmount = 0;

    @observable totalVat = 0;

    // Called by StoreModel.load() after every list load. skipUpdate loads are lookups
    // from other pages (sale drawer etc.) and must not touch the Betalinger footer.
    afterLoad(response = {}, opt = {}) {
        if (opt.skipUpdate) {
            return;
        }
        this.updateKeyValue('totalAmount', response.totalAmount || 0);
        this.updateKeyValue('totalVat', response.totalVat || 0);
    }

    @action
    setSortField(field) {
        this.sort = field;
    }

    // DELETE that returns the server response. StoreModel.delete() swallows it, which would hide a
    // 423 from the MVA-lås.
    async deletePayment(id) {
        const response = await util.fetchApi(`/api/salepayments/${id}`, { method: 'DELETE' }, {});
        return response;
    }
}

const store = new SalePaymentStore();
export default store;
